import { Routes, Route } from 'react-router-dom';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';
import StartLayout from '../layouts/StartLayout';
import {
    PageNotFound,
    LoginPage,
    DashboardPage,
    ClientsPage,
    ClientProfilePage,
    UsersPage,
    ProductsPage,
    ProfilePage,
    GoogleLoginPage,
    CreateClientPage,
    SettingsPage,
    InsurancePage,
    ThemesPage,
    StatisticPage,
    UserCommunicationPage,
    FAQPage,
    ContactPage,
    PrivateIdTestingPage,
} from '../pages';
import CreatePackagePage from '../pages/InsurancePage/CreatePackagePage/CreatePackagePage';
import GeneralSettingsPage from '../pages/SettingsPage/GeneralSettingsPage';
import ApiKeysPage from '../pages/SettingsPage/ApiKeysPage/ApiKeysPage';
import NotificationsSettingsPage from '../pages/SettingsPage/NotificationsSettingsPage';
import PrivacyPolicySettingsPage from '../pages/SettingsPage/PrivacyPolicySettingsPage';
import TermsOfUseSettingsPage from '../pages/SettingsPage/TermsOfUseSettingsPage';
import InsuranceStatisticPage from '../pages/StatisticPage/InsuranceStatisticPage/InsuranceStatisticPage';
import {
    ClientCoachMeSubPage,
    ClientDashboardSubPage,
    ClientDetailsSubPage,
    ClientInsuranceSubPage,
    ClientNotificationsSubPage,
    ClientPrivacySubPage,
    ClientProductsSubPage,
    ClientSftpSubPage,
    ClientTermsSubPage,
    CrmSubPage,
    UserCommunicationSubPage,
    ClientWebAppSubPage,
} from '../pages/ClientProfilePage/SubPages';

import {
    // GeneralTypePage,
    EmailTypePage,
    SmsTypePage,
    SlackTypePage,
    PushTypePage,
} from '../pages/ClientProfilePage/SubPages/ClientNotificationsSubPage/NotificationsTypesPages';
import {
    CrmUsersPage,
    CrmSettingsPage,
} from '../pages/ClientProfilePage/SubPages/CrmSubPage/SubPages';
import {
    UserCommunicationEmailFooterPage,
    UserCommunicationGeneralPage,
    UserCommunicationRetentionPage,
    UserCommunicationSystemPage,
    UserCommunicationTimingsPage,
    UserCommunicationWelcomePage,
} from '../pages/ClientProfilePage/SubPages/UserCommunicationSubPage/SubPages';
import {
    UserCommunicationGeneralPage as GeneralUserCommunicationGeneralPage,
    UserCommunicationSystemPage as GeneralUserCommunicationSystemPage,
    UserCommunicationWelcomePage as GeneralUserCommunicationWelcomePage,
    UserCommunicationRetentionPage as GeneralUserCommunicationRetentionPage,
    UserCommunicationEmailFooterPage as GeneralUserCommunicationEmailFooterPage,
    UserCommunicationTimingsPage as GeneralUserCommunicationTimingsPage,
} from '../pages/UserCommunicationPage/SubPages';
import {
    DefaultsSubPage,
    EmailDriversSubPage,
    SmsDriversSubPage,
    SlackDriversSubPage,
    PushDriversSubPage,
} from '../pages/SettingsPage/NotificationsSettingsPage/SubPages';
import {
    WelcomeReminders,
    EmailRetention,
    SmsRetention,
} from '../pages/ClientProfilePage/SubPages/UserCommunicationSubPage/SubPages/UserCommunicationTimingsPage/SubPages';
import CreateFAQPage from '../pages/FAQPage/CreateFAQPage';
import GroupsPage from '../pages/FAQPage/GroupsPage';
import CreateContactPage from '../pages/ContactPage/CreateContactPage';

export default function MainRoutes() {
    return (
        <Routes>
            <Route element={<StartLayout />}>
                <Route
                    path="testing/privateid"
                    element={<PrivateIdTestingPage />}
                />
            </Route>
            <Route element={<PublicRoute />}>
                <Route path="/" element={<LoginPage />} />
                <Route
                    path="google/auth/callback"
                    element={<GoogleLoginPage />}
                />
            </Route>
            <Route element={<PrivateRoute />}>
                <Route path="dashboard" element={<DashboardPage />} />
                <Route path="users" element={<UsersPage />} />
                <Route path="products" element={<ProductsPage />} />
                <Route path="clients" element={<ClientsPage />} />
                <Route path="clients/create" element={<CreateClientPage />} />
                <Route path="clients/:id/*" element={<ClientProfilePage />}>
                    <Route
                        path="dashboard"
                        element={<ClientDashboardSubPage />}
                    />
                    <Route path="details" element={<ClientDetailsSubPage />} />
                    <Route
                        path="activated-products"
                        element={<ClientProductsSubPage />}
                    />
                    <Route path="coach-me" element={<ClientCoachMeSubPage />} />
                    <Route
                        path="terms-of-use"
                        element={<ClientTermsSubPage />}
                    />
                    <Route
                        path="privacy-policy"
                        element={<ClientPrivacySubPage />}
                    />
                    <Route
                        path="notifications"
                        element={<ClientNotificationsSubPage />}
                    >
                        {/* <Route path="general" element={<GeneralTypePage />} /> */}
                        <Route path="email" element={<EmailTypePage />} />
                        <Route path="sms" element={<SmsTypePage />} />
                        <Route path="slack" element={<SlackTypePage />} />
                        <Route path="push" element={<PushTypePage />} />
                    </Route>
                    <Route path="crm" element={<CrmSubPage />}>
                        <Route path="users" element={<CrmUsersPage />} />
                        <Route path="settings" element={<CrmSettingsPage />} />
                    </Route>
                    <Route path="web-app" element={<ClientWebAppSubPage />}>
                        <Route path="users" element={<CrmUsersPage />} />
                        <Route path="settings" element={<CrmSettingsPage />} />
                    </Route>
                    <Route
                        path="insurance"
                        element={<ClientInsuranceSubPage />}
                    />
                    <Route path="sftp" element={<ClientSftpSubPage />} />
                    <Route
                        path="communication"
                        element={<UserCommunicationSubPage />}
                    >
                        <Route
                            path="general"
                            element={<UserCommunicationGeneralPage />}
                        />
                        <Route
                            path="system"
                            element={<UserCommunicationSystemPage />}
                        />
                        <Route
                            path="welcome"
                            element={<UserCommunicationWelcomePage />}
                        />
                        <Route
                            path="retention"
                            element={<UserCommunicationRetentionPage />}
                        />
                        <Route
                            path="email-footer"
                            element={<UserCommunicationEmailFooterPage />}
                        />
                        <Route
                            path="timings"
                            element={<UserCommunicationTimingsPage />}
                        >
                            <Route
                                path="welcome-reminders"
                                element={<WelcomeReminders />}
                            />
                            <Route
                                path="email-retention"
                                element={<EmailRetention />}
                            />
                            <Route
                                path="sms-retention"
                                element={<SmsRetention />}
                            />
                        </Route>
                    </Route>
                </Route>
                <Route path="themes" element={<ThemesPage />} />
                <Route path="settings" element={<SettingsPage />}>
                    <Route path="general" element={<GeneralSettingsPage />} />
                    <Route path="api-keys" element={<ApiKeysPage />} />
                    <Route
                        path="notifications"
                        element={<NotificationsSettingsPage />}
                    >
                        <Route path="defaults" element={<DefaultsSubPage />} />
                        <Route
                            path="email-drivers"
                            element={<EmailDriversSubPage />}
                        />
                        <Route
                            path="sms-drivers"
                            element={<SmsDriversSubPage />}
                        />
                        <Route
                            path="slack-drivers"
                            element={<SlackDriversSubPage />}
                        />
                        <Route
                            path="push-drivers"
                            element={<PushDriversSubPage />}
                        />
                    </Route>
                    <Route
                        path="terms-of-use"
                        element={<TermsOfUseSettingsPage />}
                    />
                    <Route
                        path="privacy-policy"
                        element={<PrivacyPolicySettingsPage />}
                    />
                </Route>
                <Route path="insurance" element={<InsurancePage />} />
                <Route
                    path="insurance/package/create"
                    element={<CreatePackagePage />}
                />
                <Route
                    path="insurance/package/:id/edit"
                    element={<CreatePackagePage />}
                />
                <Route path="statistic">
                    <Route path="users" element={<StatisticPage />} />
                    <Route
                        path="insurance"
                        element={<InsuranceStatisticPage />}
                    />
                </Route>
                <Route path="faq" element={<FAQPage />} />
                <Route path="faq/create" element={<CreateFAQPage />} />
                <Route path="faq/:id/edit" element={<CreateFAQPage />} />
                <Route path="faq/groups" element={<GroupsPage />} />
                <Route path="contact" element={<ContactPage />} />
                <Route path="contact/create" element={<CreateContactPage />} />
                <Route
                    path="contact/:id/edit"
                    element={<CreateContactPage />}
                />
                <Route path="communication" element={<UserCommunicationPage />}>
                    <Route
                        path="general"
                        element={<GeneralUserCommunicationGeneralPage />}
                    />
                    <Route
                        path="system"
                        element={<GeneralUserCommunicationSystemPage />}
                    />
                    <Route
                        path="welcome"
                        element={<GeneralUserCommunicationWelcomePage />}
                    />
                    <Route
                        path="retention"
                        element={<GeneralUserCommunicationRetentionPage />}
                    />
                    <Route
                        path="email-footer"
                        element={<GeneralUserCommunicationEmailFooterPage />}
                    />
                    <Route
                        path="timings"
                        element={<GeneralUserCommunicationTimingsPage />}
                    />
                </Route>

                <Route path="profile" element={<ProfilePage />} />
                <Route path="*" element={<PageNotFound />} />
            </Route>
        </Routes>
    );
}
